import React from 'react';

import { styled } from '@spazious/dollhouse-theme';

import { Flex, FlexProps } from '../Flex/index.js';

export interface DialogContentProps extends FlexProps {
  children?: React.ReactNode;
  dividers?: boolean;
}

export const DialogContent = styled(Flex).withConfig({
  shouldForwardProp: (prop) => !['dividers'].includes(prop as string),
  displayName: 'DialogContent',
})<DialogContentProps>`
  // Add iOS momentum scrolling for iOS < 13.0
  -webkit-overflow-scrolling: touch;
  overflow-y: auto;
  flex: 1 1 auto;
  padding: 20px 24px;
  ${({ dividers }) =>
    dividers
      ? `
        padding: 16px 24px;
        border-top: 1px solid #efefef;
        border-bottom: 1px solid #efefef;
      `
      : `
        padding-top: 0;
      `}
`;
